import "antd/dist/antd.min.css";
import React, {useEffect, useState} from "react";
import {useHistory, useLocation, useParams} from "react-router-dom";
import {UserApiCalls} from "../../apis/UserApiCalls";
import {Spin} from "../../components/standardization/YuJaLoading";
import useHostname from "../../hooks/useHostname";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import {useLoading} from "../../utils/LoadingContext";
import {
    ACTIVITY_EDITOR_VIEW, DELETE_QUE_BANK_MODAL_BODY,
    EDIT_QUESTION_BANK, GRADE_SCHEMA, MENU_LIST, MODAL_CANCEL_TEXT, MODAL_DELETE_TEXT,

    POLL_TITLE_LENGTH, QUESTION_BANK_TEXT, DELETE_QUE_BANK_TITLE,
    QUESTION_TYPES,
    SWITCH_POLL_MESSAGE,
    SWITCH_POLL_MODAL_TEXT,
    SWITCH_POLL_MODAL_TITLE, BANK_TITLE_TEXT
} from "../../utils/constants";
import {
    getDefaultUserSettings,
    notifyError,
    notifySuccess,
    transferUserSettings,
    validateText
} from "../../utils/helpers";
import YuJaGeneralAlert from "../../components/modals/YuJaGeneralAlert";
import {
    FormatDate, setBlankRestriction,
    trimLineBreakerInQuestion,
    trimQuestion
} from "../../utils/questionUtils";
import {QUESTION_BANK_TITLE_ERROR, UPDATE_BANK_SUCCESS} from "../../utils/toast-message-constants";
import "../CreateQuizPage/styles.css";
import {useImageLoaderManager} from "../../hooks/useImageLoaderManager";
import classes from "../CreateQuizPage/ActivityEditor.module.css";
import ActivityEditorTitleContainer from "../CreateQuizPage/ActivityEditorTitleContainer";
import ActivityEditorDashboard from "../CreateQuizPage/ActivityEditorDashboard";
import ActivityEditorMainView from "../CreateQuizPage/ActivityEditorMainView";

export default function EditQuestionProfilePage({
                                                    setSidebarContent,
                                                    setPageIdentifier
                                                }) {
    const {questionProfileId} = useParams();
    const [isSaving, setIsSaving] = useState(false);
    const [userSettings, setUserSettings] = useState(getDefaultUserSettings());
    const [currQueDisplay, setCurrQueDisplay] = useState(1);
    const {updateQuestionProfile, getQuestionProfile, deleteQuestionProfile} = UserApiCalls();
    const history = useHistory();
    const [, getSession] = useLocalStorageNew("session", {});
    const session = getSession();

    const [nextRouterPath, setNextRouterPath] = useState({pathname: '', state: null});
    const [isConfirmationPending, setIsConfirmationPending] = useState(false);
    const [alertShow, setAlertShow] = useState(false);
    const [setSaveExit, getSaveExit] = useLocalStorageNew("saveExit", false);

    const [isAutoSaving, setIsAutoSaving] = useState(null);
    const [dataLoading, setDataLoading] = useState(true);

    const [savedActivity, setSavedActivity] = useState({});
    const [draftActivity, setDraftActivity] = useState({});
    const [editorView, setEditorView] = useState(ACTIVITY_EDITOR_VIEW.QUESTION_EDITING);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const setQuestions = (questions) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        copy.questions = questions;
        setDraftActivity(copy);
    }


    const {checkAnyQuestionIsLoading} = useImageLoaderManager(draftActivity.questions, setQuestions);

    const checkChanged = () => {
        const draftStr = JSON.stringify(draftActivity);
        const savedStr = JSON.stringify(savedActivity);
        return draftStr !== savedStr;
    }

    useEffect(() => {
        let isCheckChangedPending = false;

        const unblock = history.block((location, action) => {
            if (isCheckChangedPending) {
                return true;
            }
            isCheckChangedPending = true;

            const result = checkChanged();
            if (!result || getSaveExit() === true) {
                setSaveExit(false);
                return true;
            }

            if (location.pathname && !isConfirmationPending) {
                setNextRouterPath({pathname: location.pathname, state: location.state});
                setAlertShow(true);
                return false;
            }

            return true;
        });

        if (isConfirmationPending) {
            history.push(nextRouterPath.pathname, nextRouterPath.state);
            setIsConfirmationPending(false);
            unblock();
        }

        return () => {
            unblock();
        };
    }, [history, isConfirmationPending, nextRouterPath]);

    const editQueBank = async (updatedQuestions = []) => {
        let defaultTitle = generateDefaultTitle();
        let pollToAdd = {
            questionProfileId: questionProfileId,
            title: draftActivity.pollTitle,
            questions: draftActivity.questions,
        };

        let questionsCopy = updatedQuestions && updatedQuestions.length > 0 ? JSON.parse(JSON.stringify(updatedQuestions)) : pollToAdd.questions;
        pollToAdd.title = !!pollToAdd.title ? pollToAdd.title : defaultTitle;
        for (const que of questionsCopy) {
            trimLineBreakerInQuestion(que);
        }
        pollToAdd.questions = trimQuestion(questionsCopy);

        await updateQuestionProfile(pollToAdd);

        window.onbeforeunload = undefined;
        let copy = JSON.parse(JSON.stringify(draftActivity));
        if (pollToAdd.title !== draftActivity.pollTitle
            || (updatedQuestions && updatedQuestions.length > 0)
        ) {

            if (pollToAdd.title !== draftActivity.pollTitle) {
                copy.pollTitle = pollToAdd.title;
            }

            if (updatedQuestions && updatedQuestions.length > 0) {
                copy.questions = updatedQuestions;
            }

            setDraftActivity(JSON.parse(JSON.stringify(copy)));
            setSavedActivity(copy);
        } else {
            setSavedActivity(copy);
        }
        return true;

    };

    const editQueBankClose = async () => {
        if (!validateText(draftActivity.pollTitle, POLL_TITLE_LENGTH)) {
            notifyError(QUESTION_BANK_TITLE_ERROR);
            return;
        }


        let pollToAdd = {
            questionProfileId: questionProfileId,
            title: draftActivity.pollTitle,
            questions: draftActivity.questions,
        };
        let questionsCopy = pollToAdd.questions;

        for (const que of questionsCopy) {
            trimLineBreakerInQuestion(que);
        }
        pollToAdd.questions = trimQuestion(questionsCopy);

        setIsSaving(true);
        updateQuestionProfile(pollToAdd).then(res => {
            window.onbeforeunload = undefined;
            setSavedActivity(pollToAdd);
            setDraftActivity(pollToAdd);
            notifySuccess(UPDATE_BANK_SUCCESS.replace(BANK_TITLE_TEXT, pollToAdd.title));
            history.push(MENU_LIST.QUESTION_BANKS.path);
        }) .finally(() => setIsSaving(false));
    };

    const generateDefaultTitle = () => {
        return QUESTION_BANK_TEXT + ": " + FormatDate(new Date());
    }


    useEffect(() => {
        if (!!alertShow || !!isSaving || !!showDeleteModal) {
            return;
        }

        if (checkAnyQuestionIsLoading()) {
            return;
        }

        const interval = setInterval(() => {
            if (JSON.stringify(draftActivity) !== JSON.stringify(savedActivity)) {
                setIsAutoSaving(true);
                editQueBank().finally(() => {
                    setIsAutoSaving(false);
                });
            }
        }, 10000);

        return () => {
            if (!!interval) {
                clearInterval(interval);
            }
        }
    }, [draftActivity, savedActivity, alertShow, showDeleteModal, isSaving]);

    useEffect(() => {
        setPageIdentifier(EDIT_QUESTION_BANK);
        setDataLoading(true)
        let {settings = {}} = session;
        settings = transferUserSettings(settings);
        setUserSettings(settings);

        getQuestionProfile(questionProfileId).then(res => {
            for (const question of res.questions) {
                if (question.questionType === QUESTION_TYPES.MH.name && !question.correctAnswers) {
                    question.correctAnswers = question.optionsMap;
                }
            }

            let activity = {};
            activity.pollTitle = res.title;
            activity.gradeSchema = GRADE_SCHEMA.GRADED.key;
            activity.questions = !!res.hasOwnProperty("questions") ? res.questions : [];
            setBlankRestriction(activity.questions);
            setEditorView(ACTIVITY_EDITOR_VIEW.QUESTION_EDITING);
            setSavedActivity(activity);
            setDraftActivity(JSON.parse(JSON.stringify(activity)));
        }).finally(() => setDataLoading(false));
    }, []);

    useEffect(() => {
        return () => {
            window.onbeforeunload = undefined;
        }
    }, []);


    const alertConfig = {
        title: SWITCH_POLL_MODAL_TITLE,
        okText: SWITCH_POLL_MODAL_TEXT,
        submit: async () => {
            setAlertShow(false);
            setIsConfirmationPending(true);
        },
        close: async () => {
            setAlertShow(false);
        },
    };

    const deletePollConfig = {
        title: DELETE_QUE_BANK_TITLE,
        okText: MODAL_DELETE_TEXT,
        cancelText: MODAL_CANCEL_TEXT,
        submit: () => {
            deleteQuestionProfile(questionProfileId).then(() => {
                history.push(MENU_LIST.QUESTION_BANKS.path);
            });
        },
        close: () => {
            setShowDeleteModal(false);
        },
    };



    return (
        <>
            <YuJaGeneralAlert
                show={alertShow}
                setModalShow={setAlertShow}
                content={SWITCH_POLL_MESSAGE}
                config={alertConfig}
            />
            <YuJaGeneralAlert
                show={showDeleteModal}
                setModalShow={setShowDeleteModal}
                content={DELETE_QUE_BANK_MODAL_BODY}
                config={deletePollConfig}
                AlertType={MODAL_DELETE_TEXT}
            />

            <div className={`${classes.parentContainer} ${classes.gridLayout}`}>
                <ActivityEditorTitleContainer
                    generateTitle={generateDefaultTitle}
                    dataLoading={dataLoading}
                    draftActivity={draftActivity}
                    setDraftActivity={setDraftActivity}
                    userSettings={userSettings}
                    currQueDisplay={currQueDisplay}
                    setCurrQueDisplay={setCurrQueDisplay}
                    isAutoSaving={isAutoSaving}
                    isSaving={isSaving}
                    handleSave={editQueBankClose}
                    setShowDeleteModal={setShowDeleteModal}
                    questionBankId={questionProfileId}
                    saveBtnDisabled={isSaving || isAutoSaving}
                    setEditorView={setEditorView}
                />
                <ActivityEditorDashboard
                    dataLoading={dataLoading}
                    editorView={editorView}
                    setEditorView={setEditorView}
                    draftActivity={draftActivity}
                    setQuestions={setQuestions}
                    currQueDisplay={currQueDisplay}
                    setCurrQueDisplay={setCurrQueDisplay}
                    userSettings={userSettings}
                    questionBankId={questionProfileId}
                />
                <ActivityEditorMainView
                    userSettings={userSettings}
                    dataLoading={dataLoading}
                    editorView={editorView}
                    setEditorView={setEditorView}
                    draftActivity={draftActivity}
                    setDraftActivity={setDraftActivity}
                    currQueDisplay={currQueDisplay}
                    setCurrQueDisplay={setCurrQueDisplay}
                    questionBankId={questionProfileId}
                    savePoll={editQueBank}
                />
            </div>
        </>
    );
}